export const setDataAction = (data, type) => {
    return {
        type: type,
        value: data
    }
}